// CTA PRIMÁRIO "✨ Ver decorado com IA" que flutua na foto PRINCIPAL da galeria
// (experiência V2). É a ESTRELA da capa: fundo SÓLIDO na cor de destaque do site
// (site.cor2, via prop → CSS var), texto de alto contraste, sombra + anel branco pra
// destacar sobre qualquer foto. Claramente distinto dos chips "Decorar" (pílulas glass).
// O clique NÃO abre o lightbox (stopPropagation): pede pro host abrir o TEASER — o host
// SEMPRE abre o TeaserModal (pronto/gerando → prévia; idle → resolve sob demanda),
// nunca cai direto no formulário. Em V1 as galerias não renderizam este botão.
import React from 'react';
import { ensureReadableTextColor } from '../../../utils/FunctionsGlobals';
import { abrirTeaser } from './decoradorBus';
import styles from './DecorarHeroButton.module.css';

// posicao: cada galeria escolhe a faixa LIVRE da sua capa — 'base' (default) quando os
// balões de mídia ficam no topo; 'topo' quando a fileira de balões ocupa a base (gallery3).
// cor2: cor de destaque do tenant (fundo sólido do CTA); branca/vazia → fallback escuro.
const DecorarHeroButton: React.FC<{ posicao?: 'base' | 'topo'; cor2?: string }> = ({
    posicao = 'base',
    cor2,
}) => {
    const onClick = (event: React.MouseEvent) => {
        event.stopPropagation();
        event.preventDefault();
        // sem par no detail: o host usa o teaser que já resolveu (ou resolve sob demanda)
        abrirTeaser();
    };

    // cor2 branca/ausente não daria um CTA visível → cai num acento escuro forte.
    const accent = cor2 && cor2.toLowerCase() !== '#ffffff' && cor2.toLowerCase() !== '#fff' ? cor2 : '#1e1e1e';
    const accentText = ensureReadableTextColor(undefined, accent) || '#ffffff';
    const styleVars = {
        ['--dec-cor2' as any]: accent,
        ['--dec-cor2-text' as any]: accentText,
    } as React.CSSProperties;

    return (
        <button
            type="button"
            className={`${styles.botao} ${posicao === 'topo' ? styles.topo : ''}`}
            style={styleVars}
            onClick={onClick}
            aria-label="Deseja decorar as fotos agora? Veja este imóvel decorado com IA"
            title="Deseja decorar as fotos agora? ✨"
        >
            <span className={styles.faisca} aria-hidden="true">✨</span>
            <span className={styles.label}>Deseja decorar as fotos agora?</span>
        </button>
    );
};

export default DecorarHeroButton;
